module.exports = __webpack_public_path__ + "files/ac209a9d1bd6e70ea39e96ed7c99f74d.png";